import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { setSlideKey, setTaskIdInFocus } from 'store/onboarding';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TaskSummary from 'components/onboarding/TaskSummary';
import * as Types from 'components/onboarding/typings';

interface Props {
  task: Types.Task;
  isOnHomePage: boolean;
}

function Task({ task, isOnHomePage }: Props) {
  const classes = useStyles();
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const history = useHistory();

  const { isComplete, pageStartUrl, isPro: taskIsPro } = task;
  const clientIsPro = useSelector((state: any) => state.client.isPro);

  const handleStart = () => {
    if (taskIsPro && !clientIsPro) {
      window.open('https://www.justsift.com/pricing');
      analytics.track('Onboarding Pro CTA clicked', {
        category: 'AD - Onboarding',
        label: task.title,
      });
    } else {
      dispatch(setSlideKey(task.id));
      dispatch(setTaskIdInFocus(task.id));
      pageStartUrl && history.push({ pathname: `/admin${pageStartUrl}` });
      analytics.track('Onboarding Item Start Button clicked', {
        category: 'AD - Onboarding',
        label: task.title,
      });
    }
  };

  const renderButtonText = () => {
    if (taskIsPro) {
      if (clientIsPro) {
        return isComplete ? 'View' : 'Start';
      } else {
        return isOnHomePage ? 'Learn about Sift Pro' : 'Learn More';
      }
    }

    return isComplete ? 'View' : 'Start';
  };

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <TaskSummary task={task} isOnHomePage={isOnHomePage} />
        <Button
          className={classes.button}
          onClick={handleStart}
          color="secondary"
          data-cy="onboarding-task-view-task"
        >
          {renderButtonText()}
        </Button>
      </div>
      <Divider className={classes.divider} />
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(3),
  },
  doc: {
    marginLeft: theme.spacing(5.75),
    // @ts-ignore
    color: theme.colors.gray2,
  },
  button: {
    marginLeft: 'auto',
    // (pearl) notes: using negative margin due to design wants to visually right align the button
    // while MUI considers padding for the hover effect
    marginRight: -theme.spacing(),
  },
  divider: {
    width: '100%',
    marginLeft: 0,
  },
}));

export default Task;
